import { isMobile } from '@pascal/pascal-core';

import { gameService } from '../services';

let start, end;

const reconnectDuration = isMobile() ? 0 : 5000;
// const connectionLostDuration = isMobile() ? 10000 : 15000;

export const visibilityChangeHandler = () => {
  const state = document.visibilityState;
  if (state === 'hidden') {
    start = Date.now();
  } else {
    end = Date.now();
    // if (end - start > connectionLostDuration) {
    //   gameService.handleConnectionError();
    // } else
    if (end - start > reconnectDuration) {
      gameService.handleReconnected();
    }
  }
};
